import React from 'react';
import { faqs } from '../data/content';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from './ui/accordion';

export default function FAQ() {
  return (
    <section id="faq" className="relative py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="sec-num text-sm tracking-[0.3em] uppercase" data-reveal>/ 08</p>
          <p className="mt-6 text-[13px] tracking-[0.24em] uppercase text-[#7a7369]" data-reveal style={{ '--reveal-delay': '80ms' }}>Frequently asked</p>
          <h2 className="mt-6 font-serif text-[36px] lg:text-[52px] leading-[1.03] tracking-[-0.015em] text-[#2E2C28] font-light" data-reveal style={{ '--reveal-delay': '160ms' }}>
            Answers for <span className="italic text-[#B5876C]">founders</span>.
          </h2>
          <p className="mt-8 text-base text-[#57534b] font-light leading-relaxed max-w-md" data-reveal style={{ '--reveal-delay': '240ms' }}>
            Practical answers to the questions I hear most from funded founders considering their move beyond founder-led sales.
          </p>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#d9d2ca]" data-reveal="up-sm" style={{ '--reveal-delay': `${i * 40}ms` }}>
                <AccordionTrigger className="text-left py-6 hover:no-underline group">
                  <div className="flex items-start gap-6 pr-4">
                    <span className="sec-num text-xs mt-1 tracking-[0.2em]">{String(i + 1).padStart(2, '0')}</span>
                    <span className="font-serif text-xl lg:text-2xl text-[#2E2C28] font-light leading-snug group-hover:text-[#B5876C] transition-colors duration-300">
                      {f.q}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pl-0 lg:pl-14 pr-4 pb-8 text-base lg:text-[17px] leading-[1.7] text-[#4a463f] font-light">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
